/* Constants for colors */
const COLOR_NAMES = [
  'primary', 'secondary', 'neutral', 'success', 'green', 'warning', 'yellow', 'error', 'red', 'white'
]

const ALL_COLORS = {
  primary: 'primary500', /* Unspecified shade will fallback to 500 */
  secondary: 'secondary500', /* Unspecified shade will fallback to 500 */
  neutral: 'neutral500', /* Unspecified shade will fallback to 500 */
  success: 'success500', /* Unspecified shade will fallback to 500 */
  warning: 'warning500', /* Unspecified shade will fallback to 500 */
  error: 'error500', /* Unspecified shade will fallback to 500 */
  white: 'white',
  primary100: 'primary100',
  primary300: 'primary300',
  primary500: 'primary500',
  primary700: 'primary700',
  secondary100: 'secondary100',
  secondary300: 'secondary300',
  secondary500: 'secondary500',
  secondary700: 'secondary700',
  success100: 'success100',
  success300: 'success300',
  success500: 'success500',
  success700: 'success700',
  green100: 'green100',
  green300: 'green300',
  green500: 'green500',
  green700: 'green700',
  warning100: 'warning100',
  warning300: 'warning300',
  warning500: 'warning500',
  warning700: 'warning700',
  yellow100: 'yellow100',
  yellow300: 'yellow300',
  yellow500: 'yellow500',
  yellow700: 'yellow700',
  error100: 'error100',
  error300: 'error300',
  error500: 'error500',
  error700: 'error700',
  red100: 'red100',
  red300: 'red300',
  red500: 'red500',
  red700: 'red700',
  neutral50: 'neutral50',
  neutral100: 'neutral100',
  neutral200: 'neutral200',
  neutral300: 'neutral300',
  neutral400: 'neutral400',
  neutral500: 'neutral500',
  neutral700: 'neutral700',
}

const ALL_COLOR_NAMES = Object.keys(ALL_COLORS)

export { COLOR_NAMES, ALL_COLORS, ALL_COLOR_NAMES }